import { findDataById } from './utils';

const findByRoute = (config, lPath) => {
  const path = `/${lPath.shift()}`;
  // console.info('find', path, 'inside', config, lPath);
  const select = config.routes.find(route => route.path === path);
  if (!select) return null;
  if (lPath.length > 0) return findByRoute(select, lPath);
  return select;
};

export const getRouteConfig = state => (route) => { //eslint-disable-line
  // console.info('route', route);
  const lPath = route.path.split('/').slice(1);
  return findByRoute(state.config, lPath);
};

const findById = (config, lIds) => {
  const id = `${lIds.shift()}`;
  let select = config.routes.find(route => route.id === id);
  if (!select && config.products) {
    select = config.products.find(product => product.id === id);
  }
  if (!select) return null;
  if (lIds.length > 0) return findById(select, lIds);
  return select;
};

export const getParentData = state => (id) => {
  const baseId = (id.indexOf('zooms')) ? id.replace('|zooms', '') : id;
  const parentId = baseId.split('|').slice(0, -1).join(('|'));
  return findDataById(state.config, parentId);
};

export const getDataById = state => id => findDataById(state.config, id);

export const getProductById = state => (id) => {
  const lIds = id.split('|');
  const data = findById(state.config, lIds);
  if (data.products) return data.products[0];
  if (data.face) return data;
  return null;
};

export const getProductsLinkById = state => (id) => {
  const lIds = id.split('|');
  const data = findById(state.config, lIds);
  if (data.routes) {
    if (data.routes[0].products.length > 1) {
      return { name: `${id}|${data.routes[0].id}|${data.routes[0].products[0].id}` };
    }
    return { name: `${id}|${data.routes[0].id}` };
  }
  return { name: id };
};

export const getCollectionRoutes = state => () => {
  const routes = state.config.routes;
  const collectionRouteFilter = route => route.is === 'Products';
  return routes.filter(collectionRouteFilter);
};

export const getButtonVideoConfigByConfig = state => (config) => {
  const youtubeID = window[`___${config.id}___youtube`];
  const available = config.available && youtubeID;
  const props = {
    label: state.config.common.discorverVideoLink,
    pic: config.intro['video-thumb'],
    to: { name: `${config.id}|history` },
  };
  return { available, youtubeID, props };
};
